import React from "react";

const StatusMessage = ({ winner, currentState }) => {
	// const message = winner
	// 	? `Winner is ${winner}`
	// 	: `Move of Player ${currentState.toMove ? "X" : "O"}`;

	const noMovesLeft = currentState.board.every((el) => el !== null);

	return (
		<h2 className="status-message">
			{winner && (
				<>
					Winner is{" "}
					<span className={winner === "X" ? "text-green" : "text-orange"}>
						{winner}
					</span>
				</>
			)}
			{!winner && !noMovesLeft && (
				<>
					Move of Player{" "}
					<span className={currentState.toMove ? "text-green" : "text-orange"}>
						{currentState.toMove ? "X" : "O"}
					</span>
				</>
			)}
			{!winner && noMovesLeft && (
				<>
					<span className="text-green">X</span> and {" "}
					<span className="text-orange">O</span> TIED!
				</>
			)}
		</h2>
	);
};

export default StatusMessage;
